// Zoek een ingevuld adres op bij PDOK en zeg wat het is (verifyAddressMatch).
// Nodig omdat de twee plekken die een adres invullen — het tabblad 'Gegevens'
// (useEnsureAdressLocation) en het openbare intakeformulier — anders elk hun
// eigen fetch, foutcontrole en terugval bouwen; fetchPdok.js controleert niets.
//
// Twee vragen, niet één: de exacte (`postcode:… and huisnummer:…`, alle
// woningen op dit nummer, zelfde vraag als de server) geeft bij een onbekend
// nummer NIETS terug. Dan kan de melding niet zeggen welk adres er wél in de
// buurt ligt, en daar vroeg BuurtKlusBedrijf juist om. Alleen in dat geval een
// tweede, vrije zoekopdracht voor die hint.
// AI-CONTEXT: See docs/pitfalls.md#test-mock-ignores-the-request
//
// Een storing GOOIT: 'niet gevonden' is een uitspraak over het adres, een
// storing niet.
// AI-CONTEXT: See docs/pitfalls.md#api-fallback-collapses-failure-into-empty
// AI-CONTEXT: See docs/features/postcode-huisnummer-controle.md

import verifyAddressMatch from './verifyAddressMatch'
import { buildHuisnummerUnitsUrl, buildAddressHintUrl } from './pdokQueries'

/**
 * @param {string} url
 * @param {AbortSignal|undefined} signal
 * @param {typeof fetch} fetchImpl
 * @returns {Promise<Array<object>>}
 */
const fetchDocs = async (url, signal, fetchImpl) => {
    const res = await fetchImpl(url, signal ? { signal } : undefined)
    if (!res.ok) throw new Error(`PDOK antwoordde ${res.status}`)
    const json = await res.json()
    return Array.isArray(json?.response?.docs) ? json.response.docs : []
}

/**
 * @param {object} input
 * @param {string} input.postcode
 * @param {string} input.huisnummer - Mag de toevoeging bevatten ('12a')
 * @param {string} [input.toevoeging]
 * @param {AbortSignal} [input.signal]
 * @param {typeof fetch} [input.fetchImpl]
 * @returns {Promise<import('./verifyAddressMatch').AddressCheck>}
 */
const checkAddress = async ({ postcode, huisnummer, toevoeging, signal, fetchImpl = fetch }) => {
    const invoer = { postcode, huisnummer, toevoeging }
    const zonderVraag = verifyAddressMatch([], invoer)
    if (zonderVraag.verdict === 'incomplete') return zonderVraag

    const exact = await fetchDocs(buildHuisnummerUnitsUrl(invoer), signal, fetchImpl)
    if (exact.length > 0) return verifyAddressMatch(exact, invoer)

    return verifyAddressMatch(await fetchDocs(buildAddressHintUrl(invoer), signal, fetchImpl), invoer)
}

export default checkAddress
